import React from 'react';
import { PARAMETER_LIST_QUERY } from '../queries';
import { getListBrowserStore } from '@ts-private/list-browser';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useMemo } from 'react';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import { sortBy } from 'utils/functions';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ParameterItemContainer from './ParameterItemContainer';
import { useHealthChecksAction } from '../hooks';

export const parameterListStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'parameterCode',
      caption: 'BehaviorParamTypes.Code',
      type: 'text'
    },
    {
      name: 'parameterDescription',
      caption: 'BehaviorParamTypes.Description',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'BehaviorParamTypes.Code',
      value: 'paramCode'
    },
    {
      caption: 'BehaviorParamTypes.Description',
      value: 'description'
    }
  ],
  pager: {
    orderBy: 'paramCode',
    direction: 'asc'
  }
});

const filterParams = (data, pager, filters) => {
  let params = [...data];

  if (filters.search)
    params = params.filter(item => {
      if (item.paramCode && item.paramCode.toLowerCase().trim().includes(filters.search.toLowerCase().trim())) return true;
      if (item.description && item.description.toLowerCase().trim().includes(filters.search.toLowerCase().trim())) return true;
      return false;
    });
  if (filters.parameterCode)
    params = params.filter(item => {
      return item.paramCode && item.paramCode.toLowerCase().trim().includes(filters.parameterCode.toLowerCase().trim());
    });
  if (filters.parameterDescription)
    params = params.filter(item => {
      return item.description && item.description.toLowerCase().trim().includes(filters.parameterDescription.toLowerCase().trim());
    });

  const orderBy = [];
  if (pager.orderBy) orderBy.push(pager.orderBy);
  orderBy.push('paramCode', 'description');
  sortBy(params, orderBy, pager.direction);

  return params;
};

const ParameterListBrowser = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: PARAMETER_LIST_QUERY,
        name: 'initializationParameters'
      },
      clientFilter: filterParams
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'categoryName', caption: 'BehaviorParamTypes.CategoryName' },
      { name: 'code', caption: 'BehaviorParamTypes.Code' },
      { name: 'defaultValue', caption: 'BehaviorParamTypes.DefaultValue' },
      { name: 'actions', caption: 'Actions', width: '180px' }
    ],
    []
  );

  useHealthChecksAction();

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser name='parameter-list-browser' store={parameterListStore} ItemComponent={ParameterItemContainer} columns={columns} />
      <ExportModalComponent store={parameterListStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={parameterListStore} options={fetchingOptions} />
    </Card>
  );
};

export default ParameterListBrowser;
